var map = {
	"./EffectoLogo.svg": [
		23873,
		3873
	],
	"./MinusIcon.svg": [
		18013,
		8013
	],
	"./Money.svg": [
		91810,
		1810
	],
	"./SubArrow.svg": [
		42879,
		2879
	],
	"./WhiteCheck.svg": [
		16479,
		6479
	],
	"./WhiteLogo.svg": [
		22436,
		2436
	],
	"./appStore_badge.svg": [
		59078,
		29
	],
	"./apple-store-logo.svg": [
		84578,
		4578
	],
	"./appstore.svg": [
		62098,
		2098
	],
	"./arrow-down-select.svg": [
		55719,
		5719
	],
	"./arrow-drop-down-down.svg": [
		43944,
		1563
	],
	"./arrow-drop-down-right.svg": [
		47747,
		7747
	],
	"./arrow-drop-down-up.svg": [
		33428,
		3428
	],
	"./arrow-left-white.svg": [
		38865,
		8865
	],
	"./arrow-left.svg": [
		91789,
		1789
	],
	"./arrow-right.svg": [
		75280,
		5280
	],
	"./arrowBack.svg": [
		19748
	],
	"./backArrow.svg": [
		37106,
		7106
	],
	"./banner-discount-icon.svg": [
		82654,
		2654
	],
	"./bf-landing-banner-arrow.svg": [
		76271
	],
	"./bf-landing-banner-percent.svg": [
		81687
	],
	"./black-check.svg": [
		65100,
		5100
	],
	"./black-friday/gift.svg": [
		87414,
		7414
	],
	"./black-friday/percent-circle.svg": [
		19244,
		9244
	],
	"./black-friday/shipping.svg": [
		82634,
		2634
	],
	"./blue-bubble.svg": [
		86713,
		9350
	],
	"./bookBackground.svg": [
		20741,
		741
	],
	"./booksIcons/beige_aquarius.svg": [
		61397
	],
	"./booksIcons/beige_aries.svg": [
		3928
	],
	"./booksIcons/beige_cancer.svg": [
		2546
	],
	"./booksIcons/beige_capricorn.svg": [
		29823
	],
	"./booksIcons/beige_gemini.svg": [
		96975
	],
	"./booksIcons/beige_leo.svg": [
		90430
	],
	"./booksIcons/beige_libra.svg": [
		548
	],
	"./booksIcons/beige_pisces.svg": [
		20237
	],
	"./booksIcons/beige_sagittarius.svg": [
		58220
	],
	"./booksIcons/beige_scorpio.svg": [
		69553
	],
	"./booksIcons/beige_taurus.svg": [
		31618
	],
	"./booksIcons/beige_virgo.svg": [
		13379
	],
	"./booksIcons/black_aquarius.svg": [
		58718
	],
	"./booksIcons/black_aries.svg": [
		67169
	],
	"./booksIcons/black_cancer.svg": [
		60229
	],
	"./booksIcons/black_capricorn.svg": [
		5586
	],
	"./booksIcons/black_gemini.svg": [
		14104
	],
	"./booksIcons/black_leo.svg": [
		92667
	],
	"./booksIcons/black_libra.svg": [
		98789
	],
	"./booksIcons/black_pisces.svg": [
		3718
	],
	"./booksIcons/black_sagittarius.svg": [
		57093
	],
	"./booksIcons/black_scorpio.svg": [
		3952
	],
	"./booksIcons/black_taurus.svg": [
		49005
	],
	"./booksIcons/black_virgo.svg": [
		90518
	],
	"./booksIcons/blue_aquarius.svg": [
		88235
	],
	"./booksIcons/blue_aries.svg": [
		44154
	],
	"./booksIcons/blue_cancer.svg": [
		15464
	],
	"./booksIcons/blue_capricorn.svg": [
		99465
	],
	"./booksIcons/blue_gemini.svg": [
		52117
	],
	"./booksIcons/blue_leo.svg": [
		38044
	],
	"./booksIcons/blue_libra.svg": [
		37974
	],
	"./booksIcons/blue_pisces.svg": [
		45807
	],
	"./booksIcons/blue_sagittarius.svg": [
		20062
	],
	"./booksIcons/blue_scorpio.svg": [
		85231
	],
	"./booksIcons/blue_taurus.svg": [
		55440
	],
	"./booksIcons/blue_virgo.svg": [
		84869
	],
	"./booksIcons/green_aquarius.svg": [
		50214
	],
	"./booksIcons/green_aries.svg": [
		4089
	],
	"./booksIcons/green_cancer.svg": [
		4685
	],
	"./booksIcons/green_capricorn.svg": [
		31850
	],
	"./booksIcons/green_gemini.svg": [
		39760
	],
	"./booksIcons/green_leo.svg": [
		93923
	],
	"./booksIcons/green_libra.svg": [
		66509
	],
	"./booksIcons/green_pisces.svg": [
		30670
	],
	"./booksIcons/green_sagittarius.svg": [
		26093
	],
	"./booksIcons/green_scorpio.svg": [
		61416
	],
	"./booksIcons/green_taurus.svg": [
		20965
	],
	"./booksIcons/green_virgo.svg": [
		37918
	],
	"./booksIcons/purple_aquarius.svg": [
		4545
	],
	"./booksIcons/purple_aries.svg": [
		93316
	],
	"./booksIcons/purple_cancer.svg": [
		96078
	],
	"./booksIcons/purple_capricorn.svg": [
		59971
	],
	"./booksIcons/purple_gemini.svg": [
		78619
	],
	"./booksIcons/purple_leo.svg": [
		77914
	],
	"./booksIcons/purple_libra.svg": [
		12480
	],
	"./booksIcons/purple_pisces.svg": [
		52689
	],
	"./booksIcons/purple_sagittarius.svg": [
		62640
	],
	"./booksIcons/purple_scorpio.svg": [
		20309
	],
	"./booksIcons/purple_taurus.svg": [
		50950
	],
	"./booksIcons/purple_virgo.svg": [
		66399
	],
	"./booksIcons/red_aquarius.svg": [
		41542
	],
	"./booksIcons/red_aries.svg": [
		93401
	],
	"./booksIcons/red_cancer.svg": [
		5549
	],
	"./booksIcons/red_capricorn.svg": [
		66282
	],
	"./booksIcons/red_gemini.svg": [
		89584
	],
	"./booksIcons/red_leo.svg": [
		8867
	],
	"./booksIcons/red_libra.svg": [
		67725
	],
	"./booksIcons/red_pisces.svg": [
		80590
	],
	"./booksIcons/red_sagittarius.svg": [
		51917
	],
	"./booksIcons/red_scorpio.svg": [
		27656
	],
	"./booksIcons/red_taurus.svg": [
		15653
	],
	"./booksIcons/red_virgo.svg": [
		35710
	],
	"./boy.svg": [
		52608,
		2608
	],
	"./breedIcon.svg": [
		61999,
		1999
	],
	"./burger-close.svg": [
		45634
	],
	"./burger.svg": [
		9393
	],
	"./call.svg": [
		18790,
		6409
	],
	"./carret.svg": [
		5469,
		5469
	],
	"./check-circle.svg": [
		46383,
		6383
	],
	"./check.svg": [
		75522
	],
	"./checkWithBg.svg": [
		95199,
		5199
	],
	"./checkmark-yellow.svg": [
		84306,
		4306
	],
	"./checkmark.svg": [
		17637,
		8170
	],
	"./checkout/arrow-left.svg": [
		90102,
		102
	],
	"./checkout/arrow-right.svg": [
		56661,
		6661
	],
	"./checkout/book.svg": [
		86230,
		9350
	],
	"./checkout/equal.svg": [
		52799,
		2799
	],
	"./checkout/family.svg": [
		46245,
		9350
	],
	"./checkout/hearts.svg": [
		16782,
		9350
	],
	"./checkout/music.svg": [
		1374,
		9350
	],
	"./checkout/orange-check.svg": [
		51968,
		1968
	],
	"./checkout/plus.svg": [
		86081,
		6081
	],
	"./checkout/rating.svg": [
		56218,
		6218
	],
	"./checkout/review-stars.svg": [
		17429,
		7429
	],
	"./checkout/sale-percent.svg": [
		28440,
		8440
	],
	"./checkout/thumb-with-stars.svg": [
		680,
		9350
	],
	"./checkout/track.svg": [
		23722,
		9350
	],
	"./chevron_down_icon.svg": [
		22474,
		2474
	],
	"./chevron_left_icon.svg": [
		75051,
		5051
	],
	"./circle-checkmark.svg": [
		27898,
		7898
	],
	"./circle-cross.svg": [
		68941,
		8941
	],
	"./circle-loader.svg": [
		4930
	],
	"./circle-pulse.svg": [
		60622,
		622
	],
	"./clock.svg": [
		77176,
		7176
	],
	"./closeIcon.svg": [
		23837,
		3837
	],
	"./current-weight.svg": [
		77722,
		7722
	],
	"./default-x.svg": [
		40570,
		29
	],
	"./delayIcon.svg": [
		78084,
		8084
	],
	"./discount-icon.svg": [
		90751,
		751
	],
	"./dolor-icon.svg": [
		54166,
		4166
	],
	"./download.svg": [
		62794,
		2794
	],
	"./download_green.svg": [
		8286,
		8286
	],
	"./emoji/arrow-heart.svg": [
		80285
	],
	"./emoji/baby.svg": [
		45275
	],
	"./emoji/balance.svg": [
		48513
	],
	"./emoji/big-cheek-smile.svg": [
		65065
	],
	"./emoji/books.svg": [
		58259
	],
	"./emoji/brain.svg": [
		51561
	],
	"./emoji/briefcase.svg": [
		64073
	],
	"./emoji/broken-heart.svg": [
		44575
	],
	"./emoji/celebrate.svg": [
		7086
	],
	"./emoji/cheek-smile.svg": [
		48388
	],
	"./emoji/clock.svg": [
		11295
	],
	"./emoji/colors.svg": [
		79139
	],
	"./emoji/compass.svg": [
		30293
	],
	"./emoji/correct.svg": [
		84339
	],
	"./emoji/couple.svg": [
		5199
	],
	"./emoji/crossed-hands.svg": [
		29163
	],
	"./emoji/diamond.svg": [
		10861
	],
	"./emoji/disappointed.svg": [
		26523
	],
	"./emoji/enjoy.svg": [
		64772
	],
	"./emoji/ew.svg": [
		34423
	],
	"./emoji/face-palm.svg": [
		31305
	],
	"./emoji/family.svg": [
		11787
	],
	"./emoji/finding.svg": [
		29466
	],
	"./emoji/fire-heart.svg": [
		2424
	],
	"./emoji/gift.svg": [
		4885
	],
	"./emoji/graduation.svg": [
		54499
	],
	"./emoji/gymnastic.svg": [
		75422
	],
	"./emoji/hand-heart.svg": [
		75695
	],
	"./emoji/hand.svg": [
		74344
	],
	"./emoji/head-massage.svg": [
		10535
	],
	"./emoji/healing-heart.svg": [
		32356
	],
	"./emoji/heart.svg": [
		90313
	],
	"./emoji/idk.svg": [
		28931
	],
	"./emoji/kissing.svg": [
		72755
	],
	"./emoji/laugh.svg": [
		2226
	],
	"./emoji/lily.svg": [
		91047
	],
	"./emoji/little.svg": [
		87475
	],
	"./emoji/love-letter.svg": [
		76580
	],
	"./emoji/loved.svg": [
		86613
	],
	"./emoji/magic-ball.svg": [
		60394
	],
	"./emoji/meh.svg": [
		35503
	],
	"./emoji/message.svg": [
		70892
	],
	"./emoji/money.svg": [
		46613
	],
	"./emoji/numbers.svg": [
		9307
	],
	"./emoji/palm-hand.svg": [
		78739
	],
	"./emoji/palm.svg": [
		22287
	],
	"./emoji/pink-hearts.svg": [
		96927
	],
	"./emoji/planet.svg": [
		76089
	],
	"./emoji/question-mark.svg": [
		73291
	],
	"./emoji/ring.svg": [
		58097
	],
	"./emoji/rocket.svg": [
		73719
	],
	"./emoji/sad.svg": [
		92173
	],
	"./emoji/serious.svg": [
		1551
	],
	"./emoji/smile.svg": [
		73925
	],
	"./emoji/smirk.svg": [
		84185
	],
	"./emoji/spade.svg": [
		614
	],
	"./emoji/spinning-hearts.svg": [
		14101
	],
	"./emoji/sponge.svg": [
		90333
	],
	"./emoji/star-eyes.svg": [
		80186
	],
	"./emoji/target.svg": [
		34608
	],
	"./emoji/thinking.svg": [
		48639
	],
	"./emoji/tornado.svg": [
		92686
	],
	"./emoji/wrong.svg": [
		46826
	],
	"./emoji/yoga.svg": [
		10379
	],
	"./errorIcon.svg": [
		81259,
		1259
	],
	"./exclamation-icon.svg": [
		4681,
		4681
	],
	"./exclude-icon.svg": [
		56386,
		6386
	],
	"./facebook.svg": [
		75206
	],
	"./favicon.svg": [
		2666,
		2666
	],
	"./femaleIcon.svg": [
		86277,
		6277
	],
	"./formkit_right.svg": [
		56211
	],
	"./free-shipping-icon.svg": [
		44915,
		4915
	],
	"./free-shipping.svg": [
		38543,
		8543
	],
	"./google-play-logo.svg": [
		31998,
		1998
	],
	"./googlePlay_badge.svg": [
		93285,
		29
	],
	"./green-bubble.svg": [
		39094,
		9350
	],
	"./green-check.svg": [
		15324,
		29
	],
	"./greenCheck.svg": [
		43569,
		3569
	],
	"./height.svg": [
		55655,
		5655
	],
	"./hide-eye.svg": [
		53610,
		29
	],
	"./hint-icon.svg": [
		44421,
		8170
	],
	"./home.svg": [
		28867,
		8867
	],
	"./ico-gplay.svg": [
		85731,
		5731
	],
	"./icons.svg": [
		80960
	],
	"./info-circle-solid.svg": [
		16733,
		4833
	],
	"./input-x.svg": [
		5221,
		5221
	],
	"./inputCheck.svg": [
		92358,
		2358
	],
	"./inputError.svg": [
		83324,
		3324
	],
	"./instagram.svg": [
		24226
	],
	"./like.svg": [
		91495,
		1495
	],
	"./limited-edition-star.svg": [
		47222,
		8170
	],
	"./line.svg": [
		41804,
		1804
	],
	"./linkedin.svg": [
		86468,
		6468
	],
	"./loaders/finalizing/loader-1.svg": [
		2738,
		2738
	],
	"./loaders/finalizing/loader-2.svg": [
		91425,
		1425
	],
	"./loaders/finalizing/loader-3.svg": [
		79184,
		9184
	],
	"./loaders/finalizing/loader-4.svg": [
		45071,
		5071
	],
	"./location.svg": [
		18119,
		8119
	],
	"./lock-solid.svg": [
		83689,
		4833
	],
	"./logo/favicon.svg": [
		98478
	],
	"./logo/logo-white.svg": [
		75567
	],
	"./logo/logo.svg": [
		52351
	],
	"./maleIcon.svg": [
		99966,
		9966
	],
	"./metabolic.svg": [
		21736,
		1736
	],
	"./newWordIcon.svg": [
		69211,
		9211
	],
	"./orange-bubble.svg": [
		64583,
		9350
	],
	"./payment-image.svg": [
		61107,
		4833
	],
	"./payment-methods.svg": [
		63657,
		3657
	],
	"./payments/circle-checked.svg": [
		56174,
		6174
	],
	"./payments/circle-tick-inverted.svg": [
		8042,
		8042
	],
	"./payments/circle-tick.svg": [
		82952,
		2952
	],
	"./payments/circle-unchecked.svg": [
		69973,
		9973
	],
	"./payments/credit-debit-cards.svg": [
		12730
	],
	"./payments/payment-icon1.svg": [
		82387
	],
	"./payments/payment-icon2.svg": [
		61632
	],
	"./payments/payment-icon3.svg": [
		97585,
		7585
	],
	"./payments/payment-icon4.svg": [
		99086
	],
	"./payments/payment-icon5.svg": [
		27519
	],
	"./payments/payment-methods.svg": [
		14177
	],
	"./payments/paypal-icon.svg": [
		62995
	],
	"./payments/paypyal-button.svg": [
		71175
	],
	"./payments/secure-footer.svg": [
		47063,
		4833
	],
	"./paypal-image.svg": [
		48103
	],
	"./petFoot.svg": [
		45849,
		5849
	],
	"./pink-bubble.svg": [
		26517,
		9350
	],
	"./plusIcon_circle_bg.svg": [
		87054,
		7054
	],
	"./popup-x.svg": [
		44343,
		4343
	],
	"./question-mark.svg": [
		97236,
		7236
	],
	"./quiz/background-zodiac.svg": [
		31601
	],
	"./quiz/birth-chart-left.svg": [
		88722,
		3744
	],
	"./quiz/birth-chart-right.svg": [
		86601,
		486
	],
	"./quiz/calendar.svg": [
		74006,
		4006
	],
	"./quiz/facebook.svg": [
		54632,
		4632
	],
	"./quiz/instagram.svg": [
		16240,
		6240
	],
	"./quiz/logo-footer.svg": [
		687,
		687
	],
	"./quiz/review-stars.svg": [
		64672
	],
	"./quiz/select-arrow.svg": [
		81048,
		1048
	],
	"./rating.svg": [
		54853,
		4853
	],
	"./red-x.svg": [
		24936,
		29
	],
	"./results/age.svg": [
		88928,
		8928
	],
	"./results/air.svg": [
		79961,
		8421
	],
	"./results/aquarius.svg": [
		80348,
		3222
	],
	"./results/aquarius_sign.svg": [
		92328,
		8421
	],
	"./results/aries.svg": [
		70955,
		7542
	],
	"./results/aries_sign.svg": [
		13381,
		8421
	],
	"./results/arrows-up.svg": [
		39341,
		9341
	],
	"./results/arrows.svg": [
		46873,
		8421
	],
	"./results/briefcase.svg": [
		35693,
		8421
	],
	"./results/bubble.svg": [
		52385,
		2385
	],
	"./results/calendar.svg": [
		31049,
		8421
	],
	"./results/cancer.svg": [
		89659,
		9776
	],
	"./results/cancer_sign.svg": [
		57077,
		8421
	],
	"./results/capricorn.svg": [
		88956,
		8624
	],
	"./results/capricorn_sign.svg": [
		39560,
		8421
	],
	"./results/clock.svg": [
		73867,
		8421
	],
	"./results/earth.svg": [
		51865,
		8421
	],
	"./results/fav-activity.svg": [
		97064,
		7064
	],
	"./results/female.svg": [
		98391,
		8421
	],
	"./results/fire.svg": [
		11807,
		8421
	],
	"./results/gemini.svg": [
		72422,
		8421
	],
	"./results/gemini_sign.svg": [
		48006,
		8421
	],
	"./results/gender.svg": [
		8404,
		8404
	],
	"./results/increase.svg": [
		35355,
		8421
	],
	"./results/leo.svg": [
		28025,
		8421
	],
	"./results/leo_sign.svg": [
		59911,
		8421
	],
	"./results/libra.svg": [
		35575,
		8421
	],
	"./results/libra_sign.svg": [
		94449,
		8421
	],
	"./results/list-icon.svg": [
		75611,
		5611
	],
	"./results/love-message.svg": [
		52133,
		8421
	],
	"./results/male.svg": [
		17444,
		8421
	],
	"./results/orange-bubble.svg": [
		56136,
		6136
	],
	"./results/other.svg": [
		59451,
		8421
	],
	"./results/personality.svg": [
		20221,
		221
	],
	"./results/pink_checkmark.svg": [
		20833,
		833
	],
	"./results/pisces.svg": [
		24056,
		2889
	],
	"./results/pisces_sign.svg": [
		98820,
		8421
	],
	"./results/promise-signature.svg": [
		66555,
		6555
	],
	"./results/result_background.svg": [
		37279,
		7279
	],
	"./results/results-card-svg.svg": [
		46995,
		6995
	],
	"./results/results-card-svg_mob.svg": [
		21996,
		1996
	],
	"./results/sagittarius.svg": [
		15063,
		8421
	],
	"./results/sagittarius_sign.svg": [
		10673,
		8421
	],
	"./results/scorpio.svg": [
		36358,
		2193
	],
	"./results/scorpio_sign.svg": [
		77670,
		8421
	],
	"./results/star.svg": [
		34639,
		8421
	],
	"./results/taurus.svg": [
		1595,
		1296
	],
	"./results/taurus_sign.svg": [
		39381,
		8421
	],
	"./results/virgo.svg": [
		98592,
		2315
	],
	"./results/virgo_sign.svg": [
		89612,
		8421
	],
	"./results/water.svg": [
		42956,
		8421
	],
	"./results/zodiac.svg": [
		59563,
		8421
	],
	"./reuseIcon.svg": [
		17189,
		4833
	],
	"./reviews-stars.svg": [
		92885,
		2885
	],
	"./secure-payments.svg": [
		46059,
		6059
	],
	"./select-indicator.svg": [
		62870,
		2870
	],
	"./separator.svg": [
		54627,
		4627
	],
	"./show-eye.svg": [
		93873,
		29
	],
	"./sms.svg": [
		88253,
		8253
	],
	"./social/FB.svg": [
		56914,
		6914
	],
	"./social/IG.svg": [
		26458,
		6458
	],
	"./social/Reddit.svg": [
		8930,
		8930
	],
	"./social/Telegram.svg": [
		17379,
		7379
	],
	"./social/TikTok.svg": [
		25332,
		5332
	],
	"./social/Twitter.svg": [
		65571,
		5571
	],
	"./star-check.svg": [
		79489,
		9489
	],
	"./star.svg": [
		54898,
		4898
	],
	"./sticker-bf.svg": [
		9636,
		8170
	],
	"./succesIcon.svg": [
		25507,
		5507
	],
	"./success-icon.svg": [
		90863,
		8170
	],
	"./success.svg": [
		46795,
		6795
	],
	"./tick-circle.svg": [
		4206,
		4206
	],
	"./timeline_checked.svg": [
		16501,
		6501
	],
	"./triangle.svg": [
		72882
	],
	"./upgrade/GreenCheck.svg": [
		22598,
		2598
	],
	"./upgrade/bone.svg": [
		95523,
		5523
	],
	"./upgrade/check.svg": [
		31239,
		1239
	],
	"./upgrade/like.svg": [
		30936,
		936
	],
	"./upgrade/paw.svg": [
		74943,
		4943
	],
	"./upgrade/rating.svg": [
		91822,
		1822
	],
	"./upgrade/target.svg": [
		48730,
		8730
	],
	"./upgrade/yellow-checkmark.svg": [
		63621,
		3621
	],
	"./verified.svg": [
		52530,
		2530
	],
	"./white-check.svg": [
		69558,
		8170
	],
	"./white-percent.svg": [
		34617
	],
	"./yellow-x.svg": [
		18065,
		8170
	],
	"./zodiac/aquarius.svg": [
		9538
	],
	"./zodiac/aries.svg": [
		35797
	],
	"./zodiac/cancer.svg": [
		4585
	],
	"./zodiac/capricorn.svg": [
		60878
	],
	"./zodiac/gemini.svg": [
		26700
	],
	"./zodiac/leo.svg": [
		3599
	],
	"./zodiac/libra.svg": [
		63305
	],
	"./zodiac/pisces.svg": [
		22754
	],
	"./zodiac/sagittarius.svg": [
		40081
	],
	"./zodiac/scorpio.svg": [
		3788
	],
	"./zodiac/taurus.svg": [
		14057
	],
	"./zodiac/virgo.svg": [
		88490
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 44913;
module.exports = webpackAsyncContext;